<template>
	<FormTextFieldWithBtn
		v-if="runtimeConfig.public.ENABLE_COUPON_CODES"
		id="couponCode"
		:key="appliedPromocode"
		:label="$t('couponFieldLabel')"
		:placeholder="$t('couponFieldPlaceholder')"
		:btn-label="appliedPromocode && appliedPromocode.promocode ? $t('addedToCart') : $t('apply')"
		:disabled="disableField"
		:disable-autocomplete="true"
		:initial-value="appliedPromocode ? appliedPromocode.promocode : null"
		:tooltip-msg="$t('couponFieldTooltip')"
		@input="inputChanged"
		@clicked="applyCouponCode" />
</template>

<script setup>
	import { useNuxtApp } from "#app"
	import { useCartStore } from "~/stores/CartStore"
	import { storeToRefs } from "pinia"
	import * as Sentry from "@sentry/browser"

	const runtimeConfig = useRuntimeConfig()
	const { $cartService } = useNuxtApp()
	const cartStore = useCartStore()
	const { cartId, appliedPromocode } = storeToRefs(cartStore)

	const disableField = ref(true)
	const couponValue = ref("")

	const inputChanged = ({ value }) => {
		couponValue.value = value
	}

	const testSentryLogs = (value) => {
		if (runtimeConfig.public.SENTRY.LOGGING_ENABLED && value === "LOG_ERROR") {
			const msg =
				"This is a console error log for testing. Sentry is working as expected. " +
				"This is a console error log for testing. Sentry is working as expected. " +
				"This is a console error log for testing. Sentry is working as expected. " +
				"This is a console error log for testing. Sentry is working as expected."
			console.error(msg)
			undefinedFuncForTesting()
		}
	}

	const applyCouponCode = (value) => {
		$cartService.$setPromoCode(value.value)
		testSentryLogs(value.value)
	}

	watchEffect(() => {
		const isCartEmpty = !cartId.value
		const isFieldEmpty = !couponValue.value
		const hasPromocodeApplied = appliedPromocode.value ? !!appliedPromocode.value.promocode : false
		disableField.value = isCartEmpty || isFieldEmpty || hasPromocodeApplied
	})
</script>

<style scoped></style>
